// Billing constants and the checkout link for the Account SPA. The numbers
// mirror docs/product/pricing.md and docs/reference/stripe.md; change them
// there first. The access rule itself lives in @langmail/auth-config so the
// OIDC gate and this SPA cannot disagree.

export type Cadence = 'yearly' | 'monthly'

// The dev build opens the sandbox account's links so `stripe listen` and the
// test card work; everything else is the live account.
const PAYMENT_LINKS: Record<'live' | 'sandbox', Record<Cadence, string>> = {
  live: {
    yearly: 'https://buy.stripe.com/14A14m6hp9gQ6606gIc3m02',
    monthly: 'https://buy.stripe.com/9B6eVc21978IfGAdJac3m03',
  },
  sandbox: {
    yearly: 'https://buy.stripe.com/test_14AdR81Z56q12aEbNsb3q01',
    monthly: 'https://buy.stripe.com/test_28EcN4bzF7u502w04Kb3q00',
  },
}

export const PRICES = {
  yearly: { list: 49, founding: 39.2 },
  monthly: { list: 4.99, founding: 3.99 },
} as const

// Two switches, both must hold: `open` is flipped to false by hand (same
// commit as deactivating the code in Stripe) when the hundredth member pays;
// the date is the hard stop. Keep in sync with apps/homepage/src/data/pricing.ts.
const FOUNDING = {
  code: 'FOUNDING',
  open: true,
  hardStop: new Date('2026-12-31T23:59:59Z'),
} as const

export function foundingOfferActive(now: Date = new Date()): boolean {
  return FOUNDING.open && now.getTime() <= FOUNDING.hardStop.getTime()
}

export function checkoutUrl(input: {
  cadence: Cadence
  userId: string
  email: string
  now?: Date
  sandbox?: boolean
}): string {
  const links = PAYMENT_LINKS[(input.sandbox ?? import.meta.env.DEV) ? 'sandbox' : 'live']
  const url = new URL(links[input.cadence])
  url.searchParams.set('client_reference_id', input.userId)
  url.searchParams.set('prefilled_email', input.email)
  if (foundingOfferActive(input.now)) {
    url.searchParams.set('prefilled_promo_code', FOUNDING.code)
  }
  return url.toString()
}
